(function () {
    'use strict';

    const SELECTOR = 'body.home #home-banner h1.wp-block-heading';
    const LETTER_STAGGER = 45;
    const STRONG_GAP = 320;

    // Les espaces restent des noeuds texte pour que le titre continue de passer
    // à la ligne normalement.
    function splitTextNode(node, state) {
        const fragment = document.createDocumentFragment();

        node.textContent.split(/(\s+)/).forEach(function (part) {
            if (part === '') return;

            if (/^\s+$/.test(part)) {
                fragment.appendChild(document.createTextNode(part));
                return;
            }

            const word = document.createElement('span');
            word.className = 'title-word';
            word.setAttribute('aria-hidden', 'true');

            Array.from(part).forEach(function (char) {
                const letter = document.createElement('span');
                letter.className = 'title-letter';
                letter.textContent = char;
                letter.style.setProperty('--letter-delay', (state.index * LETTER_STAGGER) + 'ms');
                state.index += 1;
                word.appendChild(letter);
            });

            fragment.appendChild(word);
        });

        node.parentNode.replaceChild(fragment, node);
    }

    // Seuls les noeuds texte sont découpés : le <strong> reste d'un bloc et
    // arrive en fondu à la fin.
    function split(heading) {
        const state = { index: 0 };

        Array.from(heading.childNodes).forEach(function (node) {
            if (node.nodeType === 3) {
                splitTextNode(node, state);
            } else if (node.nodeType === 1) {
                node.setAttribute('aria-hidden', 'true');
            }
        });

        return state.index;
    }

    function init() {
        const heading = document.querySelector(SELECTOR);
        if (!heading) return;

        // Le contenu découpé est masqué aux lecteurs d'écran : le titre reste
        // lisible via aria-label.
        const label = heading.textContent.replace(/\s+/g, ' ').trim();
        const letterCount = split(heading);
        if (!letterCount) return;

        if (label) heading.setAttribute('aria-label', label);

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        heading.classList.add('is-reveal-ready');

        const observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;

                observer.disconnect();
                heading.style.setProperty(
                    '--strong-delay',
                    (Math.max(0, letterCount - 1) * LETTER_STAGGER + STRONG_GAP) + 'ms'
                );
                requestAnimationFrame(function () {
                    heading.classList.add('is-revealing');
                });
            });
        }, { threshold: 0.25 });

        observer.observe(heading);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
        init();
    }
})();
